import * as Telecom from '@servicetitan/telecom-rtcs-client';
import log from '../../lib/log';
import { serviceState } from '../../lib/state';
import {
  discardStaleQueueDeltas,
  discardStaleQueueStatus,
} from '../../lib/coalesceWorkspaceEvents';

async function handleQueueDeleted(event: Telecom.QueueDeletedEvent) {
  discardStaleQueueStatus(event.queueId);
  discardStaleQueueDeltas(event.queueId);
  log('rtcs:queue:deleted:' + event.queueName, event);

  serviceState.queues = [
    ...serviceState.queues.filter((q) => q.id !== event.queueId),
  ];
}

export default handleQueueDeleted;
